module.exports = __webpack_public_path__ + "static/media/telegram.ba2e0e2b.svg";